<template>
	<div>
		<el-input
			:size="size"
			:style="{'max-width':width}"
			v-model="myValue"
			v-if="fieldInfo.type == 'Field_string'"
		></el-input>
		<el-input
			:size="size"
			:style="{'max-width':width}"
			v-model.number="myValue"
			v-else-if="fieldInfo.type == 'Field_int'|| fieldInfo.type == 'Field_float'"
		></el-input>
		<el-input
			:size="size"
			:style="{'max-width':width}"
			v-model.number="myValue"
			v-else-if="fieldInfo.type == 'Field_money'"
		>
			<template slot="prepend">￥</template>
		</el-input>
		<customer-input
			:size="size"
			:style="{'max-width':width}"
			v-model.number="myValue"
			:params="params"
			:filter="filter"
			v-else-if="fieldInfo.type == 'Field_user_id'"
		></customer-input>
		<el-input
			:size="size"
			:style="{'max-width':width}"
			type="textarea"
			:rows="params.rows?params.rows:3"
			placeholder="请输入内容"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_text'"
		></el-input>
		<el-input
			:size="size"
			:style="{'max-width':width}"
			type="textarea"
			:rows="params.rows?params.rows:5"
			placeholder="请输入内容, 支持 Markdown 语法"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_text_md'"
		></el-input>
		<el-select
			:size="size"
			v-model="myValue"
			placeholder="请选择"
			value-key="index"
			v-else-if="fieldInfo.type == 'Field_enum' && !params.isRadio"
		>
			<el-option
				:label="enumName"
				:value="{index:parseInt(enumIndex),name:enumName}"
				v-for="(enumName,enumIndex) in fieldInfo.enum"
				:key="enumIndex"
			></el-option>
		</el-select>
		<el-radio-group
			:size="size"
			v-model="myValue.index"
			v-else-if="fieldInfo.type == 'Field_enum' && params.isRadio"
		>
			<el-radio-button
				v-for="(enumName,enumIndex) in fieldInfo.enum"
				:key="enumIndex"
				:label="parseInt(enumIndex)"
			>{{enumName}}</el-radio-button>
		</el-radio-group>
		<editor-region
			:size="size"
			v-model="myValue"
			placeholder="请选择"
			:datas="fieldInfo.enum"
			v-else-if="fieldInfo.type == 'Field_region'"
		></editor-region>
		<el-checkbox-group :size="size" v-model="myValue" v-else-if="fieldInfo.type == 'Field_tag'">
			<el-checkbox
				v-for="(enumName,enumIndex) in fieldInfo.enum"
				:key="parseInt(enumIndex)"
				:label="parseInt(enumIndex)"
			>{{enumName}}</el-checkbox>
		</el-checkbox-group>
		<div
			v-else-if="fieldInfo.type == 'Field_relate_simple_id' || fieldInfo.type == 'Field_relate_model_id'  || fieldInfo.type == 'Field_copy_object'"
		>
			<span v-if="params.needFilter && (!params.kvFilter || params.kvFilter.length==0)">-</span>
			<editor-relateid
				:size="size"
				v-model="myValue"
				:data-model-name="fieldInfo.model_name"
				:name-fields="fieldInfo.name_fields"
				:params="params"
				:filter="filter"
				v-else
			></editor-relateid>
		</div>
		<div v-else-if="fieldInfo.type == 'Field_address'" class="row">
			<template v-if="params.isFreeMode">
				<el-select
					:size="size"
					v-model="myValue.nation.index"
					placeholder="请选择"
					value-key="index"
					class="col-4 mb-2"
					v-if="myValue.nation"
				>
					<el-option label="海外其他" value="0"></el-option>
					<el-option label="香港" value="852"></el-option>
					<el-option label="台湾" value="886"></el-option>
					<el-option label="澳门" value="853"></el-option>
					<el-option label="中国大陆" value="86"></el-option>
				</el-select>
				<el-input :size="size" v-model="myValue.name" class="col-4 mb-2">
					<template slot="prepend">姓名</template>
				</el-input>
				<el-input :size="size" v-model="myValue.phone" class="col-4 mb-2">
					<template slot="prepend">电话</template>
				</el-input>
				<div class="col-12">
					<label>详细地址</label>
					<el-input :size="size" type="textarea" v-model="myValue.street" class="mb-2"></el-input>
				</div>
			</template>
			<template v-else>
				<span v-if="params.needFilter && (!params.kvFilter || params.kvFilter.length==0)">-</span>
				<editor-relateid
					:size="size"
					v-model="myValue"
					:data-model-name="fieldInfo.model_name"
					:name-fields="fieldInfo.name_fields"
					:params="params"
					:filter="filter"
					v-else
				></editor-relateid>
			</template>
		</div>
		<editor-meta
			:size="size"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_meta'"
			:data-model-name="fieldInfo.model_name"
			:name-fields="fieldInfo.name_fields"
			:filter="fieldInfo.filter"
			:params="params"
		></editor-meta>
		<classify-input
			:size="size"
			v-model="myValue"
			:params="params"
			v-else-if="fieldInfo.type == 'Field_classify_id'"
			:data-model-name="fieldInfo.model_name"
			:name-fields="fieldInfo.name_fields"
		></classify-input>
		<editor-relate-array
			:size="size"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_relate_array'"
			:data-model-name="fieldInfo.model_name"
			:name-fields="fieldInfo.name_fields"
			:filter="filter"
			:params="params"
		></editor-relate-array>
		<editor-simple-array
			:size="size"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_simple_array'"
			:data-model-name="fieldInfo.model_name"
			:name-fields="fieldInfo.name_fields"
			:filter="filter"
			:params="params"
		></editor-simple-array>
		<editor-timestamp
			v-model="myValue"
			:params="params"
			v-else-if="fieldInfo.type == 'Field_ts'"
			:style="{'max-width':width}"
		></editor-timestamp>
		<el-input
			:size="size"
			type="password"
			placeholder="留空不修改"
			v-model="myValue"
			v-else-if="fieldInfo.type == 'Field_pwd'"
		></el-input>
		<el-switch
			:size="size"
			v-else-if="fieldInfo.type == 'Field_bool'"
			v-model="myValue"
			active-text="是"
			inactive-text="否"
		></el-switch>
		<editor-upload
			:size="size"
			v-else-if="fieldInfo.type == 'Field_pic'"
			v-model="myValue"
			:fieldInfo="fieldInfo"
			:record-model="recordModel"
			:record-id="recordId"
			:params="params"
		></editor-upload>
		<editor-uploads
			:size="size"
			v-else-if="fieldInfo.type == 'Field_pics'"
			v-model="myValue"
			:fieldInfo="fieldInfo"
			:record-model="recordModel"
			:record-id="recordId"
			:params="params"
		></editor-uploads>
		<editor-rich-text
			:size="size"
			v-else-if="fieldInfo.type == 'Field_text_rich'"
			v-model="myValue"
			:fieldInfo="fieldInfo"
			:data-model-name="fieldInfo.model_name"
			:record-id="recordId"
			:record-model="recordModel"
			:params="params"
		></editor-rich-text>
		<customer-input
			:size="size"
			v-else-if="fieldInfo.type == 'Field_userid'"
			v-model="myValue"
			:params="params"
			:record-id="recordId"
			:record-model="recordModel"
			:filter="filter"
		></customer-input>
		<admin-input
			:size="size"
			v-else-if="fieldInfo.type == 'Field_adminuser'"
			v-model="myValue"
			:params="params"
			:record-id="recordId"
			:record-model="recordModel"
			:filter="filter"
		></admin-input>
		<span v-else>{{fieldInfo.type}}</span>
		<span class="text-muted text-small" v-if="tips">{{tips}}</span>
	</div>
</template>

<script>
export default {
	name: "FieldEditor",
	data() {
		return {
			realParams: {},
			filter: { field: "", value: null },
		};
	},
	props: {
		width: {
			type: String,
			default: "100%",
		},
		tips: {
			type: String,
			default: "",
		},
		size: {
			type: String,
			default: "mini",
		},
		fieldInfo: Object,
		value: [Object, String, Number, Array, Boolean],
		recordId: {
			type: String,
			default: "",
		},
		recordModel: {
			type: String,
			default: "",
		},
		params: {
			type: Object,
			default: function() {
				return {
					allowCreate: true,
				};
			},
		},
	},
	created() {
		this.realParams = Object.assign(this.params);
	},
	computed: {
		myValue: {
			get: function() {
				if (this.value == null) {
					if (
						this.fieldInfo.type == "Field_relate_simple_id" ||
						this.fieldInfo.type == "Field_relate_model_id" ||
						this.fieldInfo.type == "Field_copy_object"
					) {
						return {
							_id: "",
							name: "",
						};
					} else if (this.fieldInfo.type == "Field_relate_array") {
						return [];
					} else if (this.fieldInfo.type == "Field_classify_id") {
						return [];
					} else if (this.fieldInfo.type == "Field_enum") {
						return {
							index: "",
							name: "",
						};
					}
				}
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", {
					field: this.fieldInfo.name,
					value: this.myValue,
				});
			},
		},
	},
	methods: {
		onWatchChange(field, newVal) {
			if (this.params.needFilter) {
				this.filter = {
					field: field,
					value: newVal,
				};
			}
		},
	},
};
</script>
